import React,{useState,useEffect,useRef}from 'react'
import { Modal,message,Form,Input, Radio,} from 'antd';
import {useYonghuUpdateQuery, useYonghuUpdateSaveMutation,} from '../../store/dianshangtaizhangApi';
import {EditOutlined,} from '@ant-design/icons';

function FirmUserEdit(props) {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const { data, isSuccess } = useYonghuUpdateQuery(
        { yh_id: props.yh_id }, 
        { skip: !open }
    );
    
    const [updateSave] = useYonghuUpdateSaveMutation();

    const [info, setInfo] = useState({
        yh_name: '',
        yh_phone: '',
        yh_state: '1',
        yh_juese: '1',
        yh_qx: '',
    }); 

    const editForm = useRef();

    useEffect(() => {
        if (isSuccess && data) {
            if (data.Status === 'success') {                
                editForm.current.setFieldsValue({
                    yh_name: data.Result.yh_name,
                    yh_phone: data.Result.yh_phone,
                    yh_state: data.Result.yh_state,
                    yh_juese: data.Result.yh_juese,
                    yh_qx: data.Result.yh_qx,
                });
                
                setInfo(prevState => ({
                    ...prevState,
                    yh_name: data.Result.yh_name,
                    yh_phone: data.Result.yh_phone,
                    yh_state: data.Result.yh_state,
                    yh_juese: data.Result.yh_juese,
                    yh_qx: data.Result.yh_qx,           
                }));
            }
        }
    }, [data, isSuccess]);

    const handleSubmit = async () => {
        try {
            const result = await updateSave({              
                "yh_id": props.yh_id,
                "yh_name": info.yh_name,
                "yh_phone": info.yh_phone,
                "yh_qy_id": props.qy_id,
                "yh_qy_name": props.qy_name,
                "yh_uid":props.eu_id,
                "yh_update_uname":props.eu_name,
                "yh_juese":info.yh_juese,
                "yh_state":info.yh_state,
                "yh_qx":info.yh_qx,
            }).unwrap();

            if (result.Status === 'success') {
                message.success('修改成功！');
                form.resetFields();
                setOpen(false);
            } else {
                message.error('修改失败！' + result.Message);
            }
        } catch (error) {
            if (error.errorFields) {
                message.error('请检查表单填写是否正确');
            } else {
                message.error('修改失败！' + (error.data?.Message || error.message));
            }
        }
    };
    
    // const onCreateEdit = (values) => {
    //     console.log('Received values of form: ', values);
    //     setOpen(false);
    // };
    // const [info,setInfo] = useState({
    //     yh_qx:''
    // }); 
    // const {data,isSuccess} = useYonghuUpdateQuery({yh_id:props.yh_id},{skip:!open})
    // const editForm = useRef()
    // useEffect(() => {
    //     if(isSuccess){
    //         if(data.Status==='success'){                
    //             editForm.current.setFieldsValue({
    //                 yh_phone:data.Result.yh_phone,
    //                 yh_name:data.Result.yh_name,
    //                 yh_qx:data.Result.yh_qx,
    //                 yh_state:data.Result.yh_state,
    //                 yh_juese:data.Result.yh_juese,
    //                 yh_qy_name:data.Result.yh_qy_name,
    //                 yh_sp_name:data.Result.yh_sp_name,
    //             })
    //             setInfo(prevState=>({...prevState,
    //                 "yh_id" : data.Result.yh_id,
    //                 "yh_name" : data.Result.yh_name,
    //                 "yh_phone" : data.Result.yh_phone,
    //                 "yh_qx" : data.Result.yh_qx,
    //                 "yh_qy_id" : data.Result.yh_qy_id,
    //                 "yh_qy_name" : data.Result.yh_qy_name,
    //                 "yh_state" : data.Result.yh_state,    
    //                 "yh_juese" : data.Result.yh_juese,    
    //                 "yh_sp_name" : data.Result.yh_sp_name,    
    //                 "yh_sp_id" : data.Result.yh_sp_id,    
    //             }))
    //         }
    //     }
    // },[data,isSuccess])
    // const [goodsEdit] = useYonghuUpdateSaveMutation()
    return (
        <>
            <a onClick={() => { setOpen(true) }}><EditOutlined /> 修改</a>
            <Modal
                width={1000}                        
                open={open}
                title='修改操作员'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={handleSubmit}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client_edit"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >                    
                    <Form.Item name="yh_name" wrapperCol={{span:10}} required label='姓名'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,yh_name:e.target.value}))
                        }}/>
                    </Form.Item>                       
                    <Form.Item name="yh_phone" wrapperCol={{span:10}} required label='手机号码'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,yh_phone:e.target.value}))
                        }}/>
                    </Form.Item>                       
                    <Form.Item name="yh_state" wrapperCol={{span:10}} required label='状态'>                        
                        <Radio.Group onChange={(e) => {
                            setInfo(prevState=>({...prevState,yh_state:e.target.value}))
                        }}>
                            <Radio value={'1'}>正常</Radio>
                            <Radio value={'2'}>禁用</Radio>
                        </Radio.Group>
                    </Form.Item>                      
                    <Form.Item name="yh_juese" wrapperCol={{span:10}} required label='角色'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,yh_juese:e.target.value}))
                        }}/>
                    </Form.Item> 
                     <Form.Item name="yh_qx" wrapperCol={{span:10}} label='权限'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,yh_qx:e.target.value}))
                        }}/>
                    </Form.Item>                       
                </Form>
            </Modal>
        </>
    )
}

export default FirmUserEdit